module.exports = __webpack_public_path__ + "static/assets/644028531e10ba137aa5d6ee006cc7af.png";